// ZoomWrapperComponent.jsx
import React from 'react';
import { Platform, View } from 'react-native';

export default function ZoomWrapperComponent({ scale = 1, style, children }) {
  if (Platform.OS !== 'web') return <>{children}</>;

  const innerStyle = {
    transform: `scale(${scale})`,
    transformOrigin: '0 0',
    width: `calc(100% / ${scale})`,
    height: `calc(100% / ${scale})`,
  };

  const outerStyle = {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  };

  return (
    <View style={outerStyle}>
      <View style={[innerStyle, style]}>{children}</View>
    </View>
  );
}
